module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "List_of_Maps"
    }
  }, [_c('p', {
    staticClass: "fm-title2"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('b', [_vm._v("LIST OF MAPS")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('p', {
    staticClass: "lom"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/08_Maps#map_1"
    }
  }, [_vm._v("Aisne and Chemin des Dames, 27 May 1918")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Maps#map_2"
    }
  }, [_vm._v("British Divisions, 27 May")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Historical_Background#map_3"
    }
  }, [_vm._v("Sector occupied by IX Corps on the 27 May 1918")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#map_4"
    }
  }, [_vm._v("German Offensives May-June 1918 (from German Official History)")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter01#map_5"
    }
  }, [_vm._v("The 50th Division sector on the eve of battle")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150 Brigade sector")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French Map showing PC Terrasse (south of Craonnelle) where Brigadier H C Rees was making for on the morning of the attack")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Front line positions held by B and D Coy 8/DLI, with support from C Coy 7/DLI morning, 27 May")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Redoubt line held by C Coy 8/DLI")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149 Brigade sector held by 6/NF, outpost line and 4/NF, battle zone")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trench map of the battle zone, held by 4/NF")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50th Division sketch map")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter02#map_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D Battery 250 Brigade RFA position")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_vm._v("The 8th Division sector on the eve of battle")]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#map_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A German map from 1916 of the Bois des Buttes, highlighting the complexity of tunnels, trenches and craters")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#map_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Brigade sector, 2/Royal Berks and 2/Rifle Brigade in the front line with 2/East Lancs in reserve")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#map_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sketch map of 5th Battery positions prepared by Mrs Massey based on reports she received from eye-witnesses. The map was prepared for the French military authorities in a bid to help find her son")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter03#map_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The 21st Division sector on the eve of battle")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trench map from May 1918, showing positions occupied by the 62 Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trench map of Cormicy and positions held by the Leicestershire Brigade")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cauroy trench map")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter04#map_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21st Division sector from a French map")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05#map_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The battle of the Aisne 1918: Stages of retreat")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05#map_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Route taken by the German 50 Infantry Division, 27-28 May")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05#map_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The retreat of the IX Corps from Vesle to Ardre")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter05#map_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The German Advance across the Aisne, 27 May to 1 June")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_General_Advice#map_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Car Tour Map")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Car_Tour_1#map_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trench map of Gernicourt wood and Berry-au-Bac")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Car_Tour_1#map_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walk 1 Map Californie Plateau")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Walk_1#map_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French trench map c. 1916. Note the cemetery to the east of Craonnelle")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Walk_1#map_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("French trench map c. 1916. Note the cemetery to the east of Craonnelle")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Walk_1#map_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walk 2 Map Bois des Buttes")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Walk_2#map_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A trench map from May 1918 showing the Bois des Buttes and surrounding area")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Walk_2#map_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walk 2 Map Bois des Buttes point 10")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_British_Cemeteries#map_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sissonne Group of cemeteries CWGC")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_British_Cemeteries#map_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vendresse group of cemeteries, which includes Jonchery British Cemetery")])]), _vm._v(" "), _c('p', {
    staticClass: "lom"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_British_Cemeteries#map_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chambrecy group of cemeteries, CWGC")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d0a204","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_List_of_Maps.vue
// module id = 72
// module chunks = 0